import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { FiLogOut } from 'react-icons/fi';
import { Modal, Button } from "react-bootstrap";
import "./logindesign.css";

const Logout = () => {
  const { logout } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleLogout = () => setShowConfirmation(true);
  const handleConfirmLogout = () => { logout(); setShowConfirmation(false); };
  const handleCancelLogout  = () => setShowConfirmation(false);

  return (
    <>
      <button onClick={handleLogout} className="logout-button" title="Sign out" aria-label="Sign out">
        <FiLogOut size={14} />
        <span style={{ fontSize: 11, letterSpacing: '0.5px' }}>Sign Out</span>
      </button>

      {/* ── Swarovski-styled confirmation modal ── */}
      <Modal show={showConfirmation} onHide={handleCancelLogout} centered>
        <Modal.Header
          closeButton
          style={{
            background: 'linear-gradient(135deg, #0d1117 0%, #1c2a3a 100%)',
            borderBottom: '1px solid rgba(201,169,110,0.2)',
            color: '#e8f0f8',
          }}
        >
          <Modal.Title style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontStyle: 'italic',
            fontSize: 18,
            color: '#c9a96e',
            letterSpacing: 1,
          }}>
            Sign Out
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{
          background: '#111827',
          color: 'rgba(200,212,224,0.75)',
          fontSize: 13,
          padding: '20px 24px',
          fontFamily: "'Inter', sans-serif",
        }}>
          Are you sure you want to sign out of Swarovski Crystal?
        </Modal.Body>

        <Modal.Footer style={{
          background: '#111827',
          borderTop: '1px solid rgba(201,169,110,0.15)',
          gap: 8,
        }}>
          <Button
            onClick={handleCancelLogout}
            style={{
              background: 'rgba(200,212,224,0.08)',
              border: '1px solid rgba(200,212,224,0.2)',
              color: '#a8b8c8',
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '0.5px',
              borderRadius: 7,
              padding: '6px 18px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmLogout}
            style={{
              background: 'linear-gradient(135deg, #c9a96e 0%, #a8793e 100%)',
              border: 'none',
              color: '#fff',
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '1px',
              textTransform: 'uppercase',
              borderRadius: 7,
              padding: '6px 20px',
              boxShadow: '0 4px 14px rgba(201,169,110,0.35)',
            }}
          >
            Sign Out
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Logout;
